<!--div cadastrar tema-->
<div class="container-fluid">
    <div class="row">
        <div class="col-md-12 ">

            <i class="fa fa-long-arrow-left inicio ml-1" aria-hidden="true"><a routerLink='/inicio' class="text-left inicio">
                Inicio</a></i>

            <h1 class="fs-54 text-center" id="temas">Temas</h1>
            <h5 class="fs-18 text-center">Veja aqui todos os temas cadastrados ou cadastre novos:</h5>

            <div class="row d-flex justify-content-center mt-4 mb-5">
                <div class="col-md-3">

                    <div class="form-group">
                        <input [(ngModel)]='tema.descricao' type="text" class="form-control" id=descricao placeholder="digite a descrição do tema">
                    </div>

                    <div class="d-flex justify-content-center">
                        <button (click)='cadastrar()' class="btn" id="botao-cadastrar" >Cadastrar</button>
                    </div>

                </div>
            </div>

        </div>

    </div>
</div>
<!--div cadastrar tema-->

<div class="container">
    <div class="row mt-5">
        <div class="col-md-12">
            <h2 class="text-center" id="todos-temas">Todos os temas</h2>
        </div>
    </div>
    <!--div tabela de todos os temas cadastrados-->
    <div class="row mt-3 mb-5 d-flex justify-content-center">
        <div class="col-md-6">
           
            <table class="table table-hover">
                <thead>
                  <tr>
                    <th scope="col">id</th>
                    <th scope="col">Descrição do tema</th>
                    <th scope="col" class="text-right">Modificações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor='let tema of listaTemas'>  
                  <th>{{tema.id}}</th>
                    <td>{{tema.descricao}}</td> 
                    <td class="d-flex justify-content-end">
                      <button [routerLink]="['/tema-edit',tema.id]" class="btn mr-3" id="botao-editar">Editar</button>
                      <button [routerLink]="['/tema-delete',tema.id]" class="btn btn-danger" id="botao-apagar">Apagar</button>
                    </td>
                  </tr> 
                </tbody>
              </table>
              
        </div>
    </div>
    <!--div tabela de todos os temas cadastrados-->
</div>